import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

interface UseBackendValidationRequestProps<TParams, TResponse> {
    queryKeyPrefix: readonly string[];
    request: (params: TParams) => Promise<TResponse>;
}

interface RequestValidationParams<TParams> {
    validationKey: string;
    params: TParams;
}

export const useBackendValidationRequest = <TParams, TResponse>({
    queryKeyPrefix,
    request,
}: UseBackendValidationRequestProps<TParams, TResponse>) => {
    const queryClient = useQueryClient();

    const requestValidation = useCallback(
        ({ validationKey, params }: RequestValidationParams<TParams>): Promise<TResponse> => {
            return queryClient.fetchQuery({
                queryKey: [...queryKeyPrefix, validationKey],
                queryFn: () => request(params),
                staleTime: Infinity,
            });
        },
        [queryClient, queryKeyPrefix, request]
    );

    return requestValidation;
};
